import clsx from 'clsx';
import { NavLink } from 'react-router';

import { ROUTES } from '@/shared/config';

import styles from './BottomBar.module.scss';

// Все пять вкладок кита (узел 161:6706) кликабельны — Рейтинг получил
// экран (узел 438:51329).
const TABS = [
  { to: ROUTES.home, icon: 'home', label: 'Главная' },
  { to: ROUTES.draws, icon: 'draws', label: 'Розыгрыш' },
  { to: ROUTES.matches, icon: 'predict', label: 'Прогноз' },
  { to: ROUTES.career, icon: 'cup', label: 'Карьера' },
  { to: ROUTES.rating, icon: 'rate', label: 'Рейтинг' },
] as const;

export function BottomBar() {
  return (
    <nav className={styles.root} aria-label="Разделы" data-testid="bottom-bar">
      {TABS.map((tab) => (
        <NavLink
          key={tab.label}
          to={tab.to}
          end={tab.to === ROUTES.home}
          className={clsx(styles.tab)}
        >
          {({ isActive }) => (
            <>
              <span className={clsx(styles.iconTag, isActive && styles.active)}>
                <img src={`/images/nav/${tab.icon}.svg`} alt="" aria-hidden className={styles.icon} />
              </span>
              <span className={styles.label}>{tab.label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
